import ApiClient from '@lib/apiClient';

export const fetchStatusCount = async () => {
	const { data } = await ApiClient.GET('getStatusCount');
	return data;
};

export const fetchDashboardOrderList = async (apiKey, queryParams) => {
	const { data } = await ApiClient.GET(apiKey, queryParams);
	return data;
};

export const getOrderByOrderDashboardId = async (queryParams) => {
	const { data } = await ApiClient.GET('getOrderDashboardReports', queryParams);
	return data;
};

// completionDate (YYYY-MM-DD) signs the tasks off on that day instead of today; leaving it
// out keeps the server stamping the moment of the call.
export const completeOrderStepByIdList = async (postData, completionDate = null) => {
	const dateParam = completionDate ? `&completionDate=${completionDate}` : '';
	const { data } = await ApiClient.POST(
		'completeOrderSteps',
		'',
		`?idList=${postData.join(',')}${dateParam}`
	);
	return data;
};

export const getOrderDashboardFilterOptions = async (queryParams) => {
	const { data } = await ApiClient.GET('getOrderDashboardFilterOptions', queryParams);
	return data;
};

export const getOrderDashboardFilterOptionSearch = async (queryParams) => {
	const { data } = await ApiClient.GET('getOrderDashboardFilterOptionSearch', queryParams);
	return data;
};

export const getQcReportHtml = async (reportId) => {
	const { data } = await ApiClient.GET('getQcReportHtml', `${reportId}/html`, false, {
		responseType: 'text'
	});
	return data;
};
